import { HeaderCell } from '../HeaderCell/HeaderCell';

export function ReadonlyColumnHeader({
  field,
  name,
  description,
}: Readonly<{
  field: string;
  name: string;
  description?: string;
}>) {
  return (
    <HeaderCell
      field={field}
      title={name}
      description={description}
      quickActions={() => null}
      menuOptions={[]}
      onMenuOptionClick={() => {}}
    />
  );
}
